import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import {
    Autocomplete, Box, Button, Divider, FormControl, IconButton, InputLabel, MenuItem,
    Modal, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, TextField, Tooltip, Typography, RadioGroup, Radio, FormControlLabel,
    Checkbox,
    CircularProgress
} from '@mui/material';
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import { CommonPatientDetails } from './CommonComponents';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import { localGetItem } from '../../Utility/Services/CacheProviderService';
import { DateTime } from 'luxon';
import CommonValidation from '../CommonFunctions/CommonValidation';
import moment from 'moment/moment';
import { AmountFormat } from '../CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../Utility/Constants';

class PackageDeatailPop extends Component {
    constructor(props) {
        super(props);

        var timeString = this.props.PatientDetails?.surgery_time ? this.props.PatientDetails?.surgery_time : "00:00:00";
        var timeArray = timeString.split(':');
        var dateObj = new Date();
        dateObj.setHours(parseInt(timeArray[0], 10));
        dateObj.setMinutes(parseInt(timeArray[1], 10));
        dateObj.setSeconds(parseInt(timeArray[2], 10));

        this.state = {
            open: true,
            roomChangeDate: this.props?.OTHome ? new Date(this.props.PatientDetails?.surgery_date) : new Date(),
            roomChangeTime: this.props?.OTHome ? dateObj : new Date(),
            Comments: "",
            PatientDetails: this.props.PatientDetails,
            serviceTemplateData: [],
            SelectedPackageID: this.props.PatientDetails?.package_id,
            SelectedPackage: null,
            SelectedSurgeon: this.props.PatientDetails?.surgeon_name,
            SelectedAnaesthetist: this.props.PatientDetails?.anaesthetist,
            DoctorData: "",
            counsellorName: "",
            TotalAmount: 0,
            DiscountPercent: this.props.PatientDetails?.discount_percentage ? this.props.PatientDetails.discount_percentage : "",
            DiscountAmount: this.props.PatientDetails?.discount_amount ? this.props.PatientDetails.discount_amount : "",
            PackageAmount: 0,
            isDisable: false,
            surgeryNameData: [],
            surgeryName: this.props.PatientDetails?.surgery_name,
            PackageData: [],
            doctorComments:'',
            OTRoomData: [],
            selectedSlot: null,
            selectedPaymentType: this.props.PatientDetails?.primary_payment_type || '',
            CorporateList: [],
            InsuranceList: [],
            selectedCorporate: null,
            selectedInsurance: this.props.PatientDetails?.insurance_company_name || null,
            selectedInsuranceNumber: this.props.PatientDetails?.policy_number || '',
            selectedInsuranceCCNNumber: this.props.PatientDetails?.ccn_number || '',
            selectedCorporateNumber: this.props.PatientDetails?.employee_id || '',
            selectedCorporateId: this.props.PatientDetails?.employer || null,
            selectedTPAName: this.props.PatientDetails?.tpa_name || null,
            TPAList: [],
            isTPAConfig: (localGetItem('tpa_insurance_config')) ? JSON.parse(localGetItem('tpa_insurance_config')) : false,
            corpPaymentType: (this.props.PatientDetails?.credit_type === 'Corporate credit' || this.props.PatientDetails?.credit_type === 'Corporate credit') ? true : (this.props.PatientDetails?.primary_payment_type === 'Corporate credit' || this.props.PatientDetails?.primary_payment_type === 'Corporate credit') ? true : false,
            insPaymentType: this.props.PatientDetails?.credit_type === 'Insurance credit' ? true : this.props.PatientDetails?.primary_payment_type === 'Insurance credit' ? true : false,
        }
        this.dropdownRef = React.createRef();
    }

    componentDidMount = () => {
        if (!this.props.OTHome && !this.props.fromOtIpRequest) {
            this.TransmittedData()
        }
        if (this.props.fromOtIpRequest) {
            this.GetOTRoomList()
        }
        if (this.props.PatientDetails?.surgery_name && (this.props.PatientDetails?.package_id || (this.props.OTHome && this.props.PatientDetails?.package_name))) {
            this.getServiceTemplateData()
            this.GetPackageList()
        } else if (this.props.PatientDetails?.surgery_name) {
            this.GetPackageList()
        }
        this.getDoctorList()
        this.getSurgeryNameList()
        // insurance option get
        this.getInsuranceList()
        this.getCorporateList()
        this.getTPAlist()
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        if (myUser?.counsellor_name) {
            this.setState({
                counsellorName: myUser?.counsellor_name
            })
        }

        if ((this.props.PatientDetails.status === "Completed" || this.props.PatientDetails.status === "Draft" || this.props.PatientDetails.status === "Cancelled") && (!this.props.OTHome && !this.props.fromOtIpRequest)) {
            this.setState({
                isDisable: this.props.PatientDetails.status === "Draft" ? false : true
            }, () => {
                this.TransmittedData()
            })
        } else if (this.props.OTHome) {
            this.setState({
                isDisable: true
            })
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    GetOTRoomList() {
        try {
            let dateOfSurgery = typeof (this.state.roomChangeDate) === 'string' ? this.state.roomChangeDate : DateTime.fromJSDate(this.state.roomChangeDate).toFormat('yyyy-MM-dd')
            RestAPIService.getAll(Serviceurls.OT_ROOM_CONFIG + `?surgery_date=${(dateOfSurgery)}`).
                then((response) => {
                    if (response.data.status === "success") {
                        let data = response.data.data?.length > 0 ? response.data.data : []
                        this.setState({
                            OTRoomData: data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        this.props.ErrorMsg(error.response.data?.message)
                    } else {
                        this.props.ErrorMsg(error.message)
                    }
                })
        }
        catch (error) {
            this.props.ErrorMsg(error.message)
        }
    }

    getCorporateList() {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE + `?clinic_id=${this.props.ClinicID}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        const Data = response?.data?.data || [];
                        this.setState({
                            CorporateList: Data,
                            selectedCorporate: Data.find(item => item?.id === this.props.PatientDetails?.employer || this.props.PatientDetails?.employer_id) || null,
                        })
                    }
                }).catch((error) => {
                    this.props.ErrorMsg(error?.response?.data?.message || error.message)
                })
        }
        catch (e) {
            this.props.ErrorMsg(e.message)
        }
    }

    getTPAlist = () => {
        try {
            RestAPIService.getAll(Serviceurls.TPA_List + `?clinic_id=${this.props.ClinicID}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            TPAList: response?.data?.data ? response?.data?.data : []
                        })
                    }
                }).catch((error) => {
                    this.props.ErrorMsg(error?.response?.data?.message || error.message)
                })
        }
        catch (e) {
            this.props.ErrorMsg(e?.message)
        }

    }

    getInsuranceList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST + `?clinic_id=${this.props.ClinicID}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            InsuranceList: response?.data?.data || [],
                        })
                    }
                }).catch((error) => {
                    this.props.ErrorMsg(error?.response?.data?.message || error.message)
                })
        } catch (e) {
            this.props.ErrorMsg(e.message)
        }
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ isDropdownOpen: false });
        }
    };

    getSurgeryNameList = () => {
        let states = this.state
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH + `?clinic_id=${this.props.ClinicID}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        if (response?.data?.data?.length > 0) {
                            response?.data?.data.forEach((item) => {
                                if (item?.surgery_key != null) {
                                    states["surgeryNameData"].push(item)
                                }
                                this.setState({ states })
                            })
                        } else {
                            this.setState({
                                surgeryNameData: response?.data?.data ? response?.data?.data : []
                            })
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.props.ErrorMsg(error.response.data.message)
                    } else {
                        this.props.ErrorMsg(error.message)
                    }
                })
        } catch (error) {
            this.props.ErrorMsg(error.message)
        }
    }

    GetPackageList = () => {
        try {
            this.setState({ Loader: true });
            
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH + `?surgery_key=${this.state.surgeryName}&clinic_id=${this.props.ClinicID}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            PackageData: response?.data?.data ? response?.data?.data : [],
                            Loader: false
                        }, ()=>{
                            if (this.props.PatientDetails?.package_id) {
                                if (localGetItem('isNewBilling') === "true") {
                                    this.setState({
                                        SelectedPackage: this.state?.PackageData?.find((list) => (list?.package_id === this.props.PatientDetails?.package_id)),
                                        PackageAmount: this.state?.PackageData?.find((list) => (list?.package_id === this.props.PatientDetails?.package_id))?.total_amount,
                                        TotalAmount: this.state?.PackageData?.find((list) => (list?.package_id === this.props.PatientDetails?.package_id))?.total_amount,
                                    })
                                } else {
                                    this.setState({
                                        SelectedPackage: this.state?.PackageData?.find((list) => (list?.id === this.props.PatientDetails?.package_id)),
                                        PackageAmount: this.state?.PackageData?.find((list) => (list?.id === this.props.PatientDetails?.package_id))?.total_amount,
                                        TotalAmount: this.state?.PackageData?.find((list) => (list?.id === this.props.PatientDetails?.package_id))?.total_amount,
                                    })
                                }
                            }
                        })
                    } else {
                        this.setState({ Loader: false });
                        this.props.ErrorMsg(response?.data?.message);
                    }
                }).catch((error) => {
                    this.setState({ Loader: false })
                    if (error?.response?.data?.message) {
                        this.props.ErrorMsg(error.response.data.message)
                    } else {
                        this.props.ErrorMsg(error.message)
                    }
                })
        } catch (error) {
            this.setState({ Loader: false })
            this.props.ErrorMsg(error.message)
        }
    }

    PostCounsellorRetransmit = (status, isSelected) => {
        try {
            let states = this.state;
            this.setState({ isDisable: true })
            var dateOfSurgery = typeof (states.roomChangeDate) === 'string' ? states.roomChangeDate : DateTime.fromJSDate(states.roomChangeDate).toFormat('yyyy-MM-dd')
            var timeOfSurgery = typeof (states.roomChangeTime?._i) === 'string' ? states.roomChangeTime?._i : DateTime.fromJSDate(states.roomChangeTime).toFormat('HH:mm:ss')
            var surgon = (states.SelectedSurgeon?.first_name ? states.SelectedSurgeon.first_name : "")
            var anaesthetist = (states.SelectedAnaesthetist?.first_name ? states.SelectedAnaesthetist.first_name : "")
            if (dateOfSurgery != "Invalid DateTime" && timeOfSurgery != "Invalid DateTime" && (surgon != " " && surgon != null) && (states?.surgeryName !== "") && (states?.SelectedPackage != null)) {
                var data = {
                    id: states.PatientDetails?.id,
                    doctor_id: states.PatientDetails?.doctor_id,
                    patient_id: states.PatientDetails?.patient_id,
                    appointment_id: states.PatientDetails?.appointment_id,
                    clinic_id: this.props.ClinicID,
                    surgery_id: this.props.PatientDetails?.surgery_id ? this.props.PatientDetails?.surgery_id : this.state.SelectedPackageID,
                    package_id: this.state.SelectedPackageID,
                    // package_id: this.props.PatientDetails?.package_id,
                    eye_type: states.PatientDetails?.eye_type,
                    surgeon_name: surgon,
                    anaesthetist: anaesthetist,
                    counsellor_name: states.counsellorName,
                    notes: this.props.CancelComments != undefined ? this.props.CancelComments : states.Comments,
                    discount_amount: +(states.DiscountAmount),
                    // gst_percentage: states.selectedGST,
                    // gst_type: states.selectedGSTtype,
                    net_amount: states.TotalAmount ? states.TotalAmount : 0,
                    status: status,
                    discount_percentage: +(states.DiscountPercent),
                    surgery_date: dateOfSurgery,
                    iol_power: this.props.PatientDetails.iol_power,
                    surgery_time: timeOfSurgery,
                    is_surgery_selected: isSelected,
                    surgery_name: this.state.surgeryName,
                    primary_payment_type: this.state.corpPaymentType ? ((localGetItem('isNewBilling') === "true") ?  'Corporate credit' : 'Corporate credit') : this.state.insPaymentType ? "Insurance credit" : "Patient credit",
                    employer_id: this.state.corpPaymentType ? (this.state.selectedCorporate?.id ? this.state.selectedCorporate?.id : this.state.selectedCorporateId) : null,
                    employee_id: this.state.corpPaymentType ? this.state.selectedCorporateNumber : "",
                    insurance_company_name: this.state.insPaymentType ? (this.state.selectedInsurance?.insurance_name ? this.state.selectedInsurance?.insurance_name : this.state.selectedInsurance) : '',
                    policy_number: this.state.insPaymentType ? this.state.selectedInsuranceNumber : '',
                    ccn_number: this.state.insPaymentType ? this.state.selectedInsuranceCCNNumber : '',
                    tpa_name: this.state.insPaymentType ? CommonValidation.removeSpace(typeof this.state.selectedTPAName === 'object' ? this.state.selectedTPAName?.tpa_name || this.state.selectedTPAName?.name || '' : this.state.selectedTPAName || '') : '',
                }
                if (this.state.corpPaymentType && (!this.state.selectedCorporate || !this.state.selectedCorporateNumber)) {
                    this.props.ErrorMsg("Please Select Corporate Details");
                    this.setState({ isDisable: false });
                } else if (this.state.insPaymentType && (!this.state.selectedInsurance || !this.state.selectedInsuranceNumber)) {
                    this.props.ErrorMsg("Please Select Insurance Details");
                    this.setState({ isDisable: false });
                } else {
                    RestAPIService.create(data, Serviceurls.COUNSELLOR_RETRANSMIT_POST)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                this.props.SuccessMsg(response.data.message)
                                this.props.handleClose()
                                this.setState({ isDisable: false })
                            }
                        }).catch((error) => {
                            if (error?.response?.data?.message) {
                                this.props.ErrorMsg(error.response.data.message)
                                this.setState({ isDisable: false })
                            } else {
                                this.props.ErrorMsg(error.message)
                                this.setState({ isDisable: false })
                            }
                        })
                }
            } else {
                if (dateOfSurgery == "Invalid DateTime") {
                    this.props.ErrorMsg("Invalid Date")
                } else if (timeOfSurgery == "Invalid DateTime") {
                    this.props.ErrorMsg("Invalid Time")
                } else if ((surgon == " " || surgon == null)) {
                    this.props.ErrorMsg("Please Enter Surgeon")
                } 
                // else if (anaesthetist == " " || anaesthetist == null) {
                //     this.props.ErrorMsg("Please Enter Anaesthetist")
                // }
                 else if (states?.surgeryName == "") {
                    this.props.ErrorMsg("Please Select Surgery")
                } else if (states?.SelectedPackage == null) {
                    this.props.ErrorMsg("Please Select Package")
                }
                this.setState({ isDisable: false })
            }
        } catch (error) {
            this.props.ErrorMsg(error.message)
            this.setState({ isDisable: false })
        }
    }

    TransmittedData = () => {
        let states = this.state
        try {
            RestAPIService.getAll(Serviceurls.COUNSELLOR_RETRANSMIT_POST + "?patient_id=" + states.PatientDetails.patient_id + "&clinic_id=" + this.props.ClinicID + "&appointment_id=" + states.PatientDetails.appointment_id)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            roomChangeDate:response?.data?.data?.surgery_date ? new Date(response?.data?.data?.surgery_date) : new Date(),
                            roomChangeTime:response.data?.data?.surgery_time ? moment(response.data?.data?.surgery_time, 'hh:mm a') : new Date(),
                            Comments: response.data?.data?.notes ? response.data?.data?.notes : response.data?.data?.counsellor_notes ? response.data?.data?.counsellor_notes : '',
                            TotalAmount: (this.props.PatientDetails.status === "Completed" || this.props.PatientDetails.status === "Draft" || this.props.PatientDetails.status === "Cancelled") && (!this.props.OTHome) ? response.data?.data?.net_amount : '',
                            DiscountPercent: (this.props.PatientDetails.status === "Completed" || this.props.PatientDetails.status === "Draft" || this.props.PatientDetails.status === "Cancelled") && (!this.props.OTHome) ? response.data?.data?.discount_percentage : '',
                            DiscountAmount: (this.props.PatientDetails.status === "Completed" || this.props.PatientDetails.status === "Draft" || this.props.PatientDetails.status === "Cancelled") && (!this.props.OTHome) ? response.data?.data?.discount : '',
                            PackageAmount: (this.props.PatientDetails.status === "Completed" || this.props.PatientDetails.status === "Draft" || this.props.PatientDetails.status === "Cancelled") && (!this.props.OTHome) ? response.data?.data?.amount : '',
                            SelectedSurgeon: response.data?.data?.surgeon_name ? response.data?.data?.surgeon_name : '',
                            SelectedAnaesthetist: response.data?.data?.anaesthetist ? response.data?.data?.anaesthetist : '',
                            surgeryName: response.data?.data?.surgery_name ? response.data?.data?.surgery_name : '',
                            doctorComments:response.data?.data?.doctor_notes ? response.data?.data?.doctor_notes : ''
                        }, () => { this.getDoctorList() })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status) {
                        this.props.ErrorMsg(error.response.data.message)
                    } else {
                        this.props.ErrorMsg(error.message)
                    }
                })
        } catch (error) {
            this.props.ErrorMsg(error.message)
        }
    }

    getServiceTemplateData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH + "?surgery_key=" + this.props.PatientDetails?.surgery_name + "&clinic_id=" + this.props.ClinicID)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let pkg_name_for_surg = [];
                        if (this.state.PatientDetails?.surgery_name) {
                            pkg_name_for_surg = response.data.data.filter((pkg) => {
                                return pkg.surgary_name === this.state.PatientDetails?.surgery_name
                            })
                        } else {
                            pkg_name_for_surg = response.data.data
                        }
                        this.setState({
                            serviceTemplateData: pkg_name_for_surg
                        }, () => {
                            if (this.props.OTHome) {
                                this.setState({
                                    SelectedPackage: this.state.serviceTemplateData.find((element) => element.package_name === this.state.PatientDetails.package_name)
                                }, () => { this.setState({ TotalAmount: this.state?.SelectedPackage?.total_amount, PackageAmount: this.state?.SelectedPackage?.package_amount }) })
                            } else {
                                this.setState({
                                    SelectedPackage: this.state.serviceTemplateData.find((element) => ((localGetItem('isNewBilling') === "true" ? element?.package_id : element.package_id) === this.state.SelectedPackageID))
                                }, () => { this.setState({ TotalAmount: this.state?.SelectedPackage?.total_amount, PackageAmount: this.state?.SelectedPackage?.package_amount }) })
                            }
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status) {
                        this.props.ErrorMsg(error.response.data.message)
                    } else {
                        this.props.ErrorMsg(error.message)
                    }
                })
        } catch (error) {
            this.props.ErrorMsg(error.message)
        }
    }
    // getServiceTemplateData = () => {
    //     try {
    //         RestAPIService.getAll(Serviceurls.FO_CONFIG_IPSRCPACKAGE + "?clinic_id=" + this.props.ClinicID)
    //             .then((response) => {
    //                 if (response.data.status === 'success') {
    //                     let pkg_name_for_surg = [];
    //                     if (this.state.PatientDetails?.surgery_name) {
    //                         pkg_name_for_surg = response.data.data.filter((pkg) => {
    //                             return pkg.surgary_name === this.state.PatientDetails?.surgery_name
    //                         })
    //                     } else {
    //                         pkg_name_for_surg = response.data.data
    //                     }
    //                     this.setState({
    //                         serviceTemplateData: pkg_name_for_surg
    //                     }, () => {
    //                         if (this.props.OTHome) {
    //                             this.setState({
    //                                 SelectedPackage: this.state.serviceTemplateData.find((element) => element.package_name === this.state.PatientDetails.package_name)
    //                             }, () => { this.setState({ TotalAmount: this.state?.SelectedPackage?.total_amount, PackageAmount: this.state?.SelectedPackage?.total_amount }) })
    //                         } else {
    //                             this.setState({
    //                                 SelectedPackage: this.state.serviceTemplateData.find((element) => element.id === this.state.SelectedPackageID)
    //                             }, () => { this.setState({ TotalAmount: this.state?.SelectedPackage?.total_amount, PackageAmount: this.state?.SelectedPackage?.total_amount }) })
    //                         }
    //                     })
    //                 }
    //             }).catch((error) => {
    //                 if (error?.response?.data?.status) {
    //                     this.props.ErrorMsg(error.response.data.message)
    //                 } else {
    //                     this.props.ErrorMsg(error.message)
    //                 }
    //             })
    //     } catch (error) {
    //         this.props.ErrorMsg(error.message)
    //     }
    // }

    ActionBtn = () => {
        if (this.props.OTHome) {
            if (this.state.Comments == "") {
                this.props.ErrorMsg("Please Enter Comments")
            } else {
                this.props.RescheduleAppointment(this.state.roomChangeDate, this.state.roomChangeTime, this.state.Comments)
            }
        } else if (this.props.fromOtIpRequest) {
            let states = this.state;
            var dateOfSurgery = typeof (states.roomChangeDate) === 'string' ? states.roomChangeDate : DateTime.fromJSDate(states.roomChangeDate).toFormat('yyyy-MM-dd')
            var timeOfSurgery = typeof (states.roomChangeTime?._i) === 'string' ? states.roomChangeTime?._i : DateTime.fromJSDate(states.roomChangeTime).toFormat('HH:mm:ss')
            var surgon = states.SelectedSurgeon?.first_name ? states.SelectedSurgeon.first_name : ""
            if (dateOfSurgery !== "Invalid DateTime" && timeOfSurgery !== "Invalid DateTime" && (surgon !== "" && surgon !== null) && states?.surgeryName !== "" && states?.SelectedPackage !== null && states.selectedSlot !== null) {
                let data = {
                    ip_admission_id: states.PatientDetails?.id ? states.PatientDetails?.id : null,
                    status: 'Approved',
                    surgery_id: states.surgery_id ? states.surgery_id : null,
                    package_id: states.SelectedPackageID ? states.SelectedPackageID : null,
                    surgery_name: states.surgeryName ? states.surgeryName : '',
                    package_name: states.PackageData?.length > 0 ? states.PackageData?.find((item) => item.id === states.SelectedPackageID)?.package_name : '',
                    surgeon_name: surgon,
                    anaesthetist: states.SelectedAnaesthetist?.first_name ? states.SelectedAnaesthetist?.first_name : '',
                    surgery_date: dateOfSurgery,
                    surgery_time: timeOfSurgery,
                    amount: states.PackageAmount ? +states.PackageAmount : null,
                    discount_amount: states.DiscountAmount ? +states.DiscountAmount : null,
                    net_amount: states.TotalAmount ? states.TotalAmount : null,
                    slot_id: states.selectedSlot?.id ? states.selectedSlot?.id : null,
                }
                this.props.proceedBtnAction(data)
            } else {
                if (dateOfSurgery === "Invalid DateTime") {
                    this.props.ErrorMsg("Invalid Date")
                } else if (timeOfSurgery === "Invalid DateTime") {
                    this.props.ErrorMsg("Invalid Time")
                } else if (states?.surgeryName == "") {
                    this.props.ErrorMsg("Please Select Surgery")
                } else if ((surgon === "" || surgon === null)) {
                    this.props.ErrorMsg("Please Enter Surgeon")
                } else if (states?.SelectedPackage === null) {
                    this.props.ErrorMsg("Please Select Package")
                } else if (states.selectedSlot === null){
                    this.props.ErrorMsg("Please Select Slot")
                }
            }
        } else {
            this.PostCounsellorRetransmit("Completed", true)
        }
    }

    getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.HOME_GET_CLINIC_DOCTORS + "?clinic_id=" + this.props.ClinicID).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            DoctorData: [{first_name:  "Surgical Team"}, ...response.data.data],
                        }, () => {
                            let Surgeon = this.state?.DoctorData.find((list) => ((list?.first_name ? list.first_name : "") === this.props.PatientDetails?.surgeon_name))
                            let Anaesthetist = this.state.DoctorData.find((list) => ((list?.first_name ? list.first_name : "") === this.props.PatientDetails?.anaesthetist))
                            this.setState({
                                SelectedSurgeon: Surgeon,
                                SelectedAnaesthetist: Anaesthetist
                            })
                        })
                    }
                    else {
                        this.props.ErrorMsg(response.data.message)
                    }
                }).catch((error) => {
                    this.props.ErrorMsg(error.message)
                })
        } catch (e) {
            this.props.ErrorMsg(e.message)
        }
    }

    handleOptionSelect = (option) => {
        let packageData = this.state.serviceTemplateData?.filter((item) => item?.id == option?.id)
        this.setState({
            surgeryName: option?.surgery_names,
            isDropdownOpen: false,
            surgery: option,
            SelectedPackage: packageData[0],
            PackageAmount: packageData[0]?.total_amount,
            DiscountAmount: "",
            DiscountPercent: "",
            TotalAmount: Math.round(+((packageData[0]?.total_amount - ((packageData[0]?.total_amount * 0) / 100)).toFixed(2))),
            SelectedPackageID: packageData[0]?.package_id
        }, () => {
            this.setState({ surgeryNameData: [] })
        });
    };

    renderTextField = (label, stateKey, mr = "", maxLength) => {
        const emedTid = stateKey.replace(/([A-Z])/g, '_$1').toLowerCase();
        return (
            <TextField
                size='small'
                autoComplete='off'
                disabled={this.state.isDisable || this.props.fromOtIpRequest || this.props?.OTHome}
                sx={{ width: '15vw', mr: mr }}
                label={label}
                value={this.state[stateKey] || ""}
                inputProps={{ maxLength: maxLength }}
                emed_tid={`pkg_detail_${emedTid}`}
                onChange={(e) => {
                    if (stateKey === "selectedInsuranceCCNNumber") {
                        var isAlphaNum = CommonValidation.alphanumValidation(e.target.value)
                        if ((isAlphaNum || e.target.value == "") && e.target.value.length <= 20) {
                            this.setState({ selectedInsuranceCCNNumber: e.target.value })
                        }
                    } else {
                        this.setState({ [stateKey]: e.target.value })
                    }
                }}
            />
        )
    }

    render() {
        let { open } = this.state;
        let { t } = this.props
        var oneYearFromNow = new Date();
        var currentDate = new Date()
        const minTime = new Date(currentDate.getTime() - 80000);
        console.log(this.state.SelectedPackage);
        
        return (
            <Modal open={open} hideBackdrop={this.props.fromOtIpRequest ? true : false} emed_tid="pkg_detail_modal">
                {this.state.Loader ? <Paper elevation={3} id="emedhub_popup_mainBox" sx={{ width: "60vw", height: "41vw" ,display:'flex',justifyContent:'center'}} emed_tid="pkg_detail_loader_paper"><CircularProgress emed_tid="pkg_detail_loader" /></Paper> :
                <Paper elevation={3} id="emedhub_popup_mainBox" sx={{ width: "60vw", height: "41vw" }} emed_tid="pkg_detail_paper">
                    <div id="emedhub_popup_header" style={{ backgroundColor: Colors.DataTblHeaderbg }} emed_tid="pkg_detail_header">
                        <Typography sx={{ color: "#616161", fontWeight: 600 }} emed_tid="pkg_detail_title">{this.props.OTHome ? t("Reschedule") : t("Package Details")}</Typography>
                        <IconButton onClick={() => { this.props.handleClose() }} size="small" emed_tid="pkg_detail_close_btn"><img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} emed_tid="pkg_detail_close_icon" /></IconButton>
                    </div>
                    <div id="emedhub_popup_container" style={{height:'34vw',overflow:'auto'}} emed_tid="pkg_detail_container">
                        <div id="popup_Patient_details" emed_tid="pkg_detail_patient_details">
                            <CommonPatientDetails data={this.props.PatientDetails} showAdmission={false} packageDetail={true} />
                            {(this.props.OTHome || this.props.fromOtIpRequest) ? null :
                                <TextField
                                    label={"Counsellor"}
                                    size='small'
                                    disabled={true}
                                    sx={{ width: '15vw' }}
                                    placeholder='Enter Counsellor Name'
                                    variant="outlined"
                                    value={this.state.counsellorName}
                                    emed_tid="pkg_detail_counsellor"
                                    onChange={(event) => {
                                        this.setState({
                                            counsellorName: event.target.value
                                        })
                                    }}
                                />
                            }
                        </div>
                        <Divider style={{ paddingTop: "0.5vw", paddingBottom: "0.5vw" }} emed_tid="pkg_detail_divider" />
                        <div className='Popup_Text_Area' emed_tid="pkg_detail_text_area">
                            {<Typography className='PopupDetail' emed_tid="pkg_detail_doctor_name_label">{this.props.fromOtIpRequest ? t("Admitting Consultant : ") : t("Ref Doctor Name : ")}<span className='PopupSubDetail' emed_tid="pkg_detail_doctor_name_value">
                                {this.state.PatientDetails?.doctor_name && this.state.PatientDetails?.doctor_name.length > 20 ? <Tooltip placement="top" title={this.state.PatientDetails?.doctor_name} arrow emed_tid="pkg_detail_doctor_name_tooltip"><div style={{ fontSize: "0.9vw", marginLeft: "0.35vw", marginTop: "0.05vw" }} emed_tid="pkg_detail_doctor_name_truncated">{this.state.PatientDetails?.doctor_name.slice(0, 18) + "..."}</div></Tooltip> : this.state.PatientDetails?.doctor_name ? this.state.PatientDetails?.doctor_name : "-"}
                            </span></Typography>}
                            {this.props?.OTHome ? <Typography className='PopupDetail' emed_tid="pkg_detail_surgery_label_othome">{t("Surgery : ")}<span className='PopupSubDetail' emed_tid="pkg_detail_surgery_value_othome">
                                {this.state.PatientDetails?.surgery_name && this.state.PatientDetails?.surgery_name.length > 20 ? <Tooltip placement="top" title={this.state.PatientDetails?.surgery_name} arrow emed_tid="pkg_detail_surgery_tooltip_othome"><div style={{ fontSize: "0.9vw", marginLeft: "0.35vw", marginTop: "0.05vw" }} emed_tid="pkg_detail_surgery_truncated_othome">{this.state.PatientDetails?.surgery_name.slice(0, 18) + "..."}</div></Tooltip> : this.state.PatientDetails?.surgery_name ? this.state.PatientDetails?.surgery_name : "-"}
                            </span></Typography> :
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }} emed_tid="pkg_detail_surgery_container">
                                    <Typography sx={{ width: "5vw" }} className='PopupDetail' emed_tid="pkg_detail_surgery_label">{t("Surgery : ")}</Typography>
                                    <div emed_tid="pkg_detail_surgery_autocomplete_container">
                                        <Autocomplete
                                            clearIcon
                                            size='small'
                                            sx={{ width: '15vw' }}
                                            freeSolo
                                            options={this.state.surgeryNameData}
                                            getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.surgery_key}
                                            value={this.state.surgeryName}
                                            autoComplete='off'
                                            disabled={this.state.isDisable}
                                            emed_tid="pkg_detail_surgery_autocomplete"
                                            onChange={(e) => {
                                                let newValue = e.target.value;
                                                if (newValue === "") {
                                                    this.setState({
                                                        // surgeryNameData: [],
                                                        // isDropdownOpen: false,
                                                        surgery: null,
                                                        surgeryName: "",
                                                        SelectedPackage: null,
                                                        PackageAmount: 0,
                                                        DiscountAmount: "",
                                                        DiscountPercent: "",
                                                        TotalAmount: 0
                                                    })
                                                }
                                            }}
                                            renderOption={(props, option) => {
                                                return (
                                                    <div onClick={() => {
                                                        this.setState({
                                                            surgeryName: option?.surgery_key,
                                                            surgery_id: option?.surgery_id,
                                                            SelectedPackage: null,
                                                            PackageAmount: 0,
                                                            DiscountAmount: "",
                                                            DiscountPercent: "",
                                                            TotalAmount: 0
                                                        }, () => { this.GetPackageList() })
                                                    }} emed_tid={`pkg_detail_surgery_option_${option?.surgery_id}`}>
                                                        <li {...props}>
                                                            {option?.surgery_key ? option?.surgery_key : null}
                                                        </li>
                                                    </div>
                                                )
                                            }}
                                            renderInput={(params) => <TextField {...params} label='Search and Select Surgery *' emed_tid="pkg_detail_surgery_input" />}
                                        />
                                    </div>
                                    {/* <div className="custom-dropdown" ref={this.dropdownRef}>
                                        <TextField
                                            label='Search and Select Surgery'
                                            autoComplete="off"
                                            size='small'
                                            sx={{ width: '15vw' }}
                                            // onClick={() => { this.handleToggleDropdown() }}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                this.setState({ package: '', surgeryName: newValue }, () => {
                                                    if (newValue.trim() === "") {
                                                        this.setState({
                                                            surgeryNameData: [],
                                                            isDropdownOpen: false,
                                                            surgery: null,
                                                            surgeryName: "",
                                                            SelectedPackage: null,
                                                            PackageAmount: 0,
                                                            DiscountAmount: 0,
                                                            DiscountPercent: 0,
                                                            TotalAmount: 0
                                                        });
                                                    } else if (this.state.surgeryName.length > 0) {
                                                        this.getSurgeryNameList();
                                                    }
                                                })
                                            }}
                                            value={this.state?.surgeryName ? this.state?.surgeryName : ""}
                                        />
                                        {(this.state.surgeryNameData?.length > 0 && this.state.isDropdownOpen) && (
                                            <div className="dropdown-content">
                                                {this.state.surgeryNameData.map((option, index) => (
                                                    <div
                                                        className="dropdown-item"
                                                        key={index}
                                                        onClick={() => { this.handleOptionSelect(option) }}
                                                    >
                                                        {`${option?.surgery_names} ${option?.package_name ? (" - " + option?.package_name) : ""}`}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div> */}
                                </div>}
                            {/* {this.state.PatientDetails?.doctor_name ?
                                <Typography className='PopupDetail'>{t("Power : ")}<span className='PopupSubDetail'></span>{this.state.PatientDetails?.doctor_name ? this.state.PatientDetails?.doctor_name : "-"}</Typography>
                                : null} */}
                            {/* {this.state.PatientDetails?.doctor_name ?
                            <Typography className='PopupDetail'>{t("Eye Type : ")}<span className='PopupSubDetail'>

                            </span></Typography>  
                            : null} */}
                        </div>
                        <div className='popup_Appoint_details' emed_tid="pkg_detail_appointment_details">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={this.state.roomChangeDate ? this.state.roomChangeDate : null}
                                    inputFormat='DD-MM-YYYY'
                                    style={{ width: '20%' }}
                                    label={t("Surgery Date")}
                                    maxDate={oneYearFromNow.setFullYear(currentDate.getFullYear() + 1)}
                                    minDate={new Date()}
                                    disabled={this.props.OTHome ? false : this.state.isDisable}
                                    emed_tid="pkg_detail_surgery_date"
                                    onChange={
                                        (newDate) => {
                                            if (newDate == null) {
                                                this.setState({
                                                    roomChangeDate: new Date()
                                                });
                                            } else {
                                                this.setState({
                                                    roomChangeDate: newDate.$d
                                                });
                                            }
                                        }}
                                    renderInput={(params) => <TextField size='small' {...params} emed_tid="pkg_detail_surgery_date_input" />}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker format="h:mm A" label={t("Surgery Time *")} minTime={this.state.isDisable ? null : (this.state.roomChangeDate > moment(currentDate)) ? null : moment(minTime)} disabled={this.props.OTHome ? false : this.state.isDisable} style={{ width: '20%' }}
                                    value={this.state.roomChangeTime ? moment(this.state.roomChangeTime, 'hh:mm a') : null}
                                    emed_tid="pkg_detail_surgery_time"
                                    onChange={(time) => {
                                        if (time == null) {
                                            this.setState({
                                                roomChangeDate: new Date()
                                            });
                                        } else {
                                            this.setState({
                                                roomChangeTime: time.$d
                                            })
                                        }
                                    }}
                                    renderInput={(props) => <TextField {...props} inputProps={{ ...props.inputProps, placeholder: "HH:MM (AM|PM)", emed_tid: 'pkg_detail_surgery_time_input' }} size="small" emed_tid="pkg_detail_surgery_time_textfield" />}
                                />
                            </LocalizationProvider>
                            <FormControl size='small' style={{ width: '20%' }} emed_tid="pkg_detail_surgeon_formcontrol">
                                <InputLabel emed_tid="pkg_detail_surgeon_label">{t('Surgeon *')}</InputLabel>
                                <Select
                                    value={this.state.SelectedSurgeon ? this.state.SelectedSurgeon : ""}
                                    label={t('Surgeon')}
                                    disabled={this.state.isDisable}
                                    emed_tid="pkg_detail_surgeon_select"
                                    onChange={(event) => {
                                        let values = event.target.value;
                                        this.setState({
                                            SelectedSurgeon: values
                                        })
                                    }}
                                    MenuProps={{
                                        style: { maxHeight: 350 },
                                    }}
                                >
                                    <MenuItem value={""} emed_tid="pkg_detail_surgeon_select_option">{"Select"}</MenuItem>
                                    {this.state.DoctorData?.length > 0 ?
                                        this.state.DoctorData.map((item, index) => {
                                            return <MenuItem key={index} value={item} emed_tid={`pkg_detail_surgeon_option_${index}`}>{(item.title ? item.title : "") + " " + (item.initial ? item.initial : "") + " " + (item.first_name ? item.first_name : "")}</MenuItem>
                                        }) : null}
                                </Select>
                            </FormControl>
                            <FormControl size='small' style={{ width: '20%' }} emed_tid="pkg_detail_anaesthetist_formcontrol">
                                <InputLabel id="Dis_lay_Diet" emed_tid="pkg_detail_anaesthetist_label">{t('Anaesthetist')}</InputLabel>
                                <Select
                                    value={this.state.SelectedAnaesthetist ? this.state.SelectedAnaesthetist : ""}
                                    label={t('Anaesthetist')}
                                    disabled={this.state.isDisable}
                                    emed_tid="pkg_detail_anaesthetist_select"
                                    onChange={(event) => {
                                        let values = event.target.value;
                                        this.setState({
                                            SelectedAnaesthetist: values
                                        })
                                    }}
                                    MenuProps={{
                                        style: { maxHeight: 350 },
                                    }}
                                >
                                    <MenuItem value={""} emed_tid="pkg_detail_anaesthetist_select_option">{"Select"}</MenuItem>
                                    {this.state.DoctorData?.length > 0 ? this.state.DoctorData.map((item, index) => {
                                        return <MenuItem key={index} value={item} emed_tid={`pkg_detail_anaesthetist_option_${index}`}>{(item.title ? item.title : "") + " " + (item.initial ? item.initial : "") + " " + (item.first_name ? item.first_name : "")}</MenuItem>
                                    }) : null}
                                </Select>
                            </FormControl>
                        </div>
                        <div emed_tid="pkg_detail_package_table_container">
                            <TableContainer emed_tid="pkg_detail_package_tablecontainer">
                                <Table emed_tid="pkg_detail_package_table">
                                    <TableHead emed_tid="pkg_detail_package_tablehead">
                                        <TableRow emed_tid="pkg_detail_package_tablehead_row">
                                            <TableCell sx={{ width: "29%" }} id="emedhub_directpoTable_headTxt" emed_tid="pkg_detail_package_name_header">{t("Package Name")}</TableCell>
                                            <TableCell sx={{ width: "17%" }} id="emedhub_directpoTable_headTxt" emed_tid="pkg_detail_amount_header">{t('Amount') + ` (${CurrencySymbol})`}</TableCell>
                                            <TableCell sx={{ width: "17%" }} id="emedhub_directpoTable_headTxt" emed_tid="pkg_detail_discount_header">{t('Discount') + ` (${CurrencySymbol})`}</TableCell>
                                            <TableCell sx={{ width: "17%" }} id="emedhub_directpoTable_headTxt" emed_tid="pkg_detail_discount_percent_header"> {t("Discount (%)")}</TableCell>
                                            <TableCell sx={{ width: "20%" }} id="emedhub_directpoTable_headTxt" emed_tid="pkg_detail_bill_amount_header">{t("Bill Amount")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody emed_tid="pkg_detail_package_tablebody">
                                        <TableRow emed_tid="pkg_detail_package_tablerow">
                                            <TableCell sx={{ width: "29%" }} emed_tid="pkg_detail_package_name_cell">
                                                <Autocomplete
                                                    disableClearable
                                                    size='medium'
                                                    value={this.state.SelectedPackage || null}
                                                    options={this.state.PackageData}
                                                    getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.package_name}
                                                    disabled={this.state.isDisable}
                                                    emed_tid="pkg_detail_package_autocomplete"
                                                    onChange={(event, newValue) => {
                                                        this.setState({
                                                            SelectedPackage: newValue,
                                                            PackageAmount: newValue?.total_amount,
                                                            DiscountAmount: "",
                                                            DiscountPercent: "",
                                                            TotalAmount: Math.round(+((newValue.total_amount - ((newValue.total_amount * 0) / 100)).toFixed(2))),
                                                            SelectedPackageID: newValue?.package_id || newValue?.id
                                                        })
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={t('Select Package *')}
                                                            emed_tid="pkg_detail_package_input"
                                                        />
                                                    )} />
                                            </TableCell>
                                            <TableCell sx={{ width: "17%" }} emed_tid="pkg_detail_amount_cell">
                                                <TextField
                                                    size='medium'
                                                    disabled={true}
                                                    variant="outlined"
                                                    value={AmountFormat(this.state.PackageAmount || 0)?.replace(`${CurrencySymbol}`, "")}
                                                    emed_tid="pkg_detail_amount_input"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            PackageAmount: event.target.value
                                                        })
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ width: "17%" }} emed_tid="pkg_detail_discount_cell">
                                                <TextField
                                                    size='medium'
                                                    variant="outlined"
                                                    disabled={this.state.isDisable}
                                                    value={this.state.DiscountAmount}
                                                    emed_tid="pkg_detail_discount_input"
                                                    onChange={(event) => {
                                                        let isValid = CommonValidation.numberOnly(event.target.value)
                                                        if (isValid && event.target.value < this.state.PackageAmount) {
                                                            this.setState({
                                                                DiscountAmount: event.target.value,
                                                                DiscountPercent: +((event.target.value * 100 / this.state.PackageAmount)).toFixed(2)
                                                            }, () => { this.setState({ TotalAmount: Math.round(+((this.state.PackageAmount - ((this.state.PackageAmount * this.state.DiscountPercent) / 100)).toFixed(2))) }) })
                                                        } else if (event.target.value == 0 || event.target.value == "") {
                                                            this.setState({
                                                                DiscountAmount: "",
                                                                DiscountPercent: "",
                                                                TotalAmount: this.state.PackageAmount
                                                            })
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ width: "17%" }} emed_tid="pkg_detail_discount_percent_cell">
                                                <TextField
                                                    size='medium'
                                                    variant="outlined"
                                                    disabled={this.state.isDisable}
                                                    value={this.state.DiscountPercent}
                                                    emed_tid="pkg_detail_discount_percent_input"
                                                    onChange={(event) => {
                                                        let isValid = CommonValidation.NumberWithDot(event.target.value)
                                                        if (isValid && event.target.value <= 100) {
                                                            let discountedAmt = ((this.state.PackageAmount * event.target.value) / 100)
                                                            this.setState({
                                                                DiscountPercent: event.target.value,
                                                                TotalAmount: Math.round(+((this.state.PackageAmount - discountedAmt).toFixed(2))),
                                                                DiscountAmount: Math.round(+(((this.state.PackageAmount * event.target.value) / 100).toFixed(2)))
                                                            })
                                                        } else if (event.target.value == 0 || event.target.value == "") {
                                                            this.setState({
                                                                DiscountPercent: "",
                                                                DiscountAmount: "",
                                                                TotalAmount: this.state.PackageAmount
                                                            })
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ width: "20%" }} emed_tid="pkg_detail_bill_amount_cell">
                                                <TextField
                                                    size='medium'
                                                    variant="outlined"
                                                    disabled={true}
                                                    value={AmountFormat(this.state.TotalAmount || 0)?.replace(`${CurrencySymbol}`, "")}
                                                    emed_tid="pkg_detail_bill_amount_input"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            TotalAmount: event.target.value
                                                        })
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <Box emed_tid="pkg_detail_admission_type_container">
                            <Box component={'div'} display={"flex"} justifyContent={"space-between"} alignItems={"center"} emed_tid="pkg_detail_admission_type_header">
                                <Typography fontSize={"1dvw"} emed_tid="pkg_detail_admission_type_label">Admission Type</Typography>
                                <Box emed_tid="pkg_detail_admission_type_checkboxes">
                                    <FormControlLabel value={"Corporate credit"} disabled={this.state.isDisable || this.props.fromOtIpRequest || this.props?.OTHome} control={<Checkbox size='small' checked={this.state.corpPaymentType} emed_tid="pkg_detail_corporate_checkbox" />} label="Corporate" emed_tid="pkg_detail_corporate_label"
                                        onChange={(e) => {
                                            this.setState({
                                                corpPaymentType: e.target.checked,
                                                selectedCorporate: null,
                                                selectedInsurance: null,
                                                selectedInsuranceNumber: '',
                                                selectedInsuranceCCNNumber: '',
                                                selectedCorporateNumber: '',
                                                selectedCorporateId: null,
                                                selectedTPAName: null,
                                                insPaymentType: false,
                                            })
                                        }} />
                                    <FormControlLabel value={"Insurance credit"} disabled={this.state.isDisable || this.props.fromOtIpRequest || this.props?.OTHome} control={<Checkbox size='small' checked={this.state.insPaymentType} emed_tid="pkg_detail_insurance_checkbox" />} label="Insurance" emed_tid="pkg_detail_insurance_label"
                                        onChange={(e) => {
                                            this.setState({
                                                insPaymentType: e.target.checked,
                                                selectedCorporate: null,
                                                selectedInsurance: null,
                                                selectedInsuranceNumber: '',
                                                selectedInsuranceCCNNumber: '',
                                                selectedCorporateNumber: '',
                                                selectedCorporateId: null,
                                                selectedTPAName: null,
                                                corpPaymentType: false
                                            })
                                        }} />
                                </Box>
                            </Box>
                            {<Box component={'div'} mt={'0.5vw'} emed_tid="pkg_detail_admission_type_details">
                                <Box component={'div'} p={'1vw'} emed_tid="pkg_detail_admission_type_details_inner">
                                    {this.state.corpPaymentType ?
                                        <Box component={'div'} display={'flex'} emed_tid="pkg_detail_corporate_container">
                                            <Autocomplete
                                                size='small'
                                                disabled={this.state.isDisable || this.props.fromOtIpRequest || this.props?.OTHome}
                                                sx={{ width: '15vw', mr: '1vw' }}
                                                options={this.state.CorporateList}
                                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.company_name}
                                                value={this.state.selectedCorporate}
                                                emed_tid="pkg_detail_corporate_autocomplete"
                                                onChange={(e, value) => {
                                                    this.setState({ selectedCorporate: value })
                                                }}
                                                renderInput={(params) => <TextField {...params} label='Select Corporate *' emed_tid="pkg_detail_corporate_input" />}
                                            />
                                            {this.renderTextField('Employee ID No *', "selectedCorporateNumber")}
                                        </Box>
                                        : this.state.insPaymentType ?
                                            <Box component={'div'} display={'flex'} emed_tid="pkg_detail_insurance_container">
                                                <Autocomplete
                                                    size='small'
                                                    disabled={this.state.isDisable || this.props.fromOtIpRequest || this.props?.OTHome}
                                                    sx={{ width: '15vw', mr: '0.75vw' }}
                                                    options={this.state.InsuranceList}
                                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.insurance_name}
                                                    value={this.state.selectedInsurance}
                                                    emed_tid="pkg_detail_insurance_autocomplete"
                                                    onChange={(e, value) => {
                                                        this.setState({ selectedInsurance: value, selectedInsuranceNumber: '', selectedInsuranceCCNNumber: '', selectedTPAName: null || "" })
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label='Select Insurance *' emed_tid="pkg_detail_insurance_input" />}
                                                />
                                                {this.renderTextField('Insurance No *', "selectedInsuranceNumber", '0.75vw')}
                                                {this.renderTextField('CCN Number', "selectedInsuranceCCNNumber", '0.75vw')}
                                                {this.state.isTPAConfig ?
                                                    <Autocomplete
                                                        disableClearable
                                                        disabled={this.state.isDisable || this.props.fromOtIpRequest || this.props?.OTHome}
                                                        sx={{ width: '15vw' }}
                                                        size='small'
                                                        clearIcon={false}
                                                        autoComplete='off'
                                                        value={this.state.selectedTPAName ? this.state.selectedTPAName : null}
                                                        options={this.state.TPAList || []}
                                                        getOptionLabel={(option) => (typeof (option) === "string" ? option : option?.tpa_name)}
                                                        emed_tid="pkg_detail_tpa_autocomplete"
                                                        onChange={(event, newValue) => {
                                                            this.setState({
                                                                selectedTPAName: newValue
                                                            })
                                                        }}
                                                        renderInput={(params) => <TextField {...params} label={"Select TPA"} emed_tid="pkg_detail_tpa_input" />}
                                                    />
                                                    : this.renderTextField('TPA Name', "selectedTPAName", '0.75vw', 50)}
                                            </Box>
                                            : null
                                    }
                                </Box>
                            </Box>}
                        </Box>
                        {this.props.fromOtIpRequest ?
                            <div style={{ display: "flex", alignItems: "center", paddingTop: "1vw", gap: '1vw' }} emed_tid="pkg_detail_ot_selection_container">
                                <Autocomplete
                                    disableClearable
                                    size='small'
                                    value={this.state.selectedOT}
                                    options={this.state.OTRoomData}
                                    getOptionLabel={(option) => (option?.ot_name)}
                                    style={{ width: "13vw" }}
                                    emed_tid="pkg_detail_ot_autocomplete"
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            selectedOT: newValue,
                                            OTdetails: newValue?.slot_data,
                                            selectedSlot: null
                                        })
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={"Select OT *"}
                                            emed_tid="pkg_detail_ot_input"
                                        />
                                    )} />
                                <Autocomplete
                                    disableClearable
                                    size="small"
                                    disabled={!this.state.selectedOT}
                                    style={{ width: "13vw" }}
                                    value={this.state.selectedSlot}
                                    options={this.state.OTdetails}
                                    getOptionLabel={(option) => (option?.slot_name)}
                                    emed_tid="pkg_detail_slot_autocomplete"
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            selectedSlot: newValue
                                        })
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t('Select Slot *')}
                                            emed_tid="pkg_detail_slot_input"
                                        />
                                    )} />
                            </div> :
                            <div style={{ marginTop: "0.5vw" }} emed_tid="pkg_detail_comments_container">
                                <TextField
                                    label={this.props.OTHome ? t("Comments*") : t("Counsellor Comments")}
                                    sx={{ width: '100%' }}
                                    multiline={true}
                                    inputProps={{ maxLength: 500 }}
                                    disabled={this.props.OTHome ? false : this.state.isDisable}
                                    rows={3}
                                    variant="outlined"
                                    value={this.state.Comments}
                                    emed_tid="pkg_detail_comments"
                                    onChange={(event) => {
                                        this.setState({
                                            Comments: event.target.value
                                        })
                                    }}
                                />
                            </div>}
                        {(this.props.OTHome || this.props.fromOtIpRequest) ? null : 
                        <Box component={'div'} mt={'1vw'} emed_tid="pkg_detail_doctor_comments_container">
                            <Typography fontSize={'0.9vw'} fontWeight={600} emed_tid="pkg_detail_doctor_comments_label">Doctor Comments</Typography>
                            <Box component={'div'} ml={'1vw'} emed_tid="pkg_detail_doctor_comments_value">{this.state.doctorComments}</Box>
                        </Box>}
                    </div>
                    <Stack id="emedhub_popup_footer" direction="row" justifyContent={"space-between"} alignItems="center" emed_tid="pkg_detail_footer">
                        <div emed_tid="pkg_detail_footer_left">
                            {(this.props.OTHome || this.props.fromOtIpRequest) ? null : <Button variant="outlined" disabled={this.state.isDisable} size="small" sx={{ textTransform: "capitalize" }} onClick={() => { this.PostCounsellorRetransmit("Draft", false) }} emed_tid="pkg_detail_save_draft_btn">{t("Save As Draft")}</Button>}
                        </div>
                        <div emed_tid="pkg_detail_footer_right">
                            <Button size="small" disabled={this.props.OTHome ? false : this.state.isDisable} sx={{ marginRight: "1vw", textTransform: "capitalize" }} variant={"contained"} onClick={() => { this.ActionBtn() }} emed_tid="pkg_detail_proceed_btn">{this.props.OTHome ? t("Reschedule") : this.props.fromOtIpRequest ? t("Proceed") : t("Confirm and Approved")}</Button>
                            <Button variant="outlined" size="small" sx={{ textTransform: "capitalize" }} onClick={() => { this.props.handleClose() }} emed_tid="pkg_detail_cancel_btn">{t("Cancel")}</Button>
                        </div>
                    </Stack>
                </Paper>}
            </Modal>
        )
    }
}
export default withTranslation()(PackageDeatailPop)